import React, { useState, FC, createRef, useEffect } from 'react';
import ClickableDropdown from './clickableDropdown';

export enum DropdownButtonTypes {
    Normal = 'normal',
    Primary = 'primary',
    Outlined = 'outlined',
}

const dropdownClassnames = {
    [DropdownButtonTypes.Normal]: 'sg-dropdown__handle',
    [DropdownButtonTypes.Outlined]: 'sg-button-action',
    [DropdownButtonTypes.Primary]: 'sg-button-primary',
};

type DropdownOption = {
    label: string;
    disabled?: boolean;
    value: string;
};

interface DropdownProps {
    options: DropdownOption[];
    value: string;
    onChange: (value: string) => void;
    label: string;
    buttonType: DropdownButtonTypes;
}

const Dropdown: FC<DropdownProps> = ({ options, onChange, label, value, buttonType = DropdownButtonTypes.Normal }) => {
    const dropdownRef = createRef<HTMLDivElement>();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (isOpen && dropdownRef.current && !dropdownRef.current.contains(event.target as HTMLDivElement)) {
                setIsOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);

    const formattedOptions = options.map((option) => ({
        title: option.label,
        disabled: option.disabled,
        onClick: () => onChange(option.value),
    }));
    const buttonName = value ? options.find((option) => option.value === value)?.label : null;

    return (
        <ClickableDropdown
            className=""
            ref={dropdownRef}
            buttonName={buttonName || label}
            buttonClass={dropdownClassnames[buttonType]}
            options={formattedOptions}
            isOpen={isOpen}
            onClick={() => {
                setIsOpen((prevState) => !prevState);
            }}
        />
    );
};

export default Dropdown;
